<template>
  <div class="card">
    <div class="card-header bg-light">
      <div class="card-header-title text-muted">
        Hình thức thanh toán
      </div>
    </div>
    <div class="card-body">
      <div class="payment-gateway clearfix"
           :class="{ 'active': payment.gateway === 'moveek' && payment.method === 'bank-transfer' }"
           @click="selectPayment('moveek', 'bank-transfer')">
        <i class="fe fe-check-circle pg-checked"></i>
        <div class="pg-info">
          <img :src="root.asset('bundles/ornweb/img/moveek-icon.png')" alt="">
          Chuyển khoản / Quét mã QR
          <span class="pm-description">
            {{ bankTransferDescription }}
          </span>
        </div>
      </div>

      <div v-if="showApplePay" class="payment-gateway clearfix"
           :class="{ 'active': payment.gateway === 'zalopay' && payment.method === 'applepay' }"
           @click="selectPayment('zalopay', 'applepay')">
        <i class="fe fe-check-circle pg-checked"></i>
        <div class="pg-info">
          <img :src="root.asset('bundles/ornweb/img/zalopay-applepay-icon.png')" alt="">
          Apple Pay
        </div>
      </div>

      <div class="payment-gateway clearfix"
           :class="{ 'active': payment.gateway === 'momo' }"
           @click="selectPayment('momo', '')">
        <i class="fe fe-check-circle pg-checked"></i>
        <div class="pg-info">
          <img :src="root.asset('bundles/ornweb/img/momo-icon.png')" alt="">
          Ví MoMo
        </div>
      </div>

      <div class="payment-gateway clearfix"
           :class="{ 'active': payment.gateway === 'payoo' && payment.method === 'cc' }"
           @click="selectPayment('payoo', 'cc')">
        <i class="fe fe-check-circle pg-checked"></i>
        <div class="pg-info">
          <img :src="root.asset('bundles/ornweb/img/payoo-icon.png')" alt="">
          Thẻ ATM / Thẻ quốc tế
        </div>
      </div>

      <div v-if="user.authenticated" class="payment-gateway clearfix"
           :class="{ 'active': payment.gateway === 'moveek' && payment.method === 'moveek-credits' }"
           @click="selectPayment('moveek', 'moveek-credits')">
        <i class="fe fe-check-circle pg-checked"></i>
        <div class="pg-info">
          <img :src="root.asset('bundles/ornweb/img/moveek-icon.png')" alt="">
          Moveek Credits
          <span class="pm-description">
            Số dư Moveek Credits:
            <strong class="text-dark">{{ useFormatting().formatCurrency(user.balance) }}</strong>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { inject } from 'vue';
import { useFormatting } from '../composables/formatting';

const props = defineProps({
  payment: Object,
  user: Object,
  amount: Object,
  showApplePay: Boolean,
  bankTransferDescription: {
    type: String,
    default: 'Tự động xuất mã vé trong 30s sau khi chuyển khoản'
  }
});
const emit = defineEmits(['update:payment', 'open:modal']);
const root = inject('root');

const selectPayment = (gateway, method) => {
  if (gateway === 'moveek' && method === 'moveek-credits' && props.user.authenticated && props.user.balance < props.amount.total) {
    emit('update:payment', { gateway: 'moveek', method: 'bank-transfer' });
    emit('open:modal', 'moveekCreditsModal');
    return;
  }
  emit('update:payment', { gateway, method });
};
</script>

